// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jKv8p","nonActiveButton":"Button_nonActiveButton__zMcbF","lessPadding":"Button_lessPadding__YZKYK","disableButton":"Button_disableButton__6SFBP"};